<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import Input from "../../components/Form/Fields/Input.svelte";
  import { initList, loading, records, record, save, onDelete, onEdit, onCreate } from "./customer-address.store";
  import { customerAddressFields } from "../../utils/TableFields/customer-address.fields";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import { isUserRoleADM } from "../../app.store";

  export let customerId: number;

  $: isNew = $record != null && $record.oid == 0;
  $: canSubmit = $record != null && !!$record.description && !!$record.city && !!$record.province;

  async function onSubmit() {
    await save();
    initList(customerId);
  }

  function onCancel() {
    initList(customerId);
  }

  onMount(() => initList(customerId));
</script>

{#if !!customerId}
  {#if !!$record}
    <div class="columns" style="height: unset;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-6">
              <FormField>
                <Input name="Descrizione" placeholder="descrizione" required={true} bind:value={$record.description} />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Switch name="Principale" bind:value={$record.headquarters} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Indirizzo" placeholder="indirizzo" required={false} bind:value={$record.street} />
              </FormField>
            </div>
            <div class="column is-1">
              <FormField>
                <Input name="Civico" placeholder="civico" required={false} bind:value={$record.civicNumber} />
              </FormField>
            </div>
            <div class="column is-3">
              <FormField>
                <Input name="Comune" placeholder="comune" required={true} bind:value={$record.city} />
              </FormField>
            </div>
            <div class="column is-1">
              <FormField>
                <Input name="Provincia" placeholder="provincia" maxlength={2} required={true} bind:value={$record.province} />
              </FormField>
            </div>
            <div class="column is-1">
              <FormField>
                <Input name="CAP" placeholder="CAP" required={false} bind:value={$record.zipCode} />
              </FormField>
            </div>
            <div class="column is-2">
              <FormField>
                <Input name="Stato" placeholder="stato" required={false} bind:value={$record.country} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}

  <Table
    loading={$loading}
    fields={customerAddressFields}
    records={$records}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={$isUserRoleADM}
    on:create={(e) => onCreate(customerId)}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
  />
{/if}
